export const SELECT_PAGE = "/randevu-al";
export const HOME = "/randevu-olustur";
export const EVALUATION = "/degerlendirme";
export const APPOINTMENT_UPDATED = "/randevu-guncelleme";
export const APPOINTMENT_EDITED = "/randevu-duzenleme";
export const APPOINTMENT_CANCEL = "/randevu-iptal";
export const EDIT_APPOINTMENT = "/duzenle";
export const SERVICE_APPOINTMENT_TIME = "/servis-adres-bilgileri"
export const SERVICE_APPOINTMENT_SERVICE = "/servis-saat-bilgileri"
export const SERVICE_APPOINTMENT_NOTE = "/servis-randevu-notu"
export const SERVICE_APPOINTMENT_USER_INFO = "/servis-randevu-kullanici-bilgileri"
export const SERVICE_APPOINTMENT_CONFIRMATION = "/servis-talebi-onayla"
export const SERVICE_APPOINTMENT_COMPLETED = "/servis-talebi-olustur"
export const SERVICE_APPOINTMENT_SUCCESS = "/servis-talebiniz-olustu"


export const SERVICE_APPOINTMENT_TYPE = "/servis-ürün-tipi"
